(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["premek-arena-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-arena')) customElements.define('np-arena', class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  if(this.classList.contains('na-highlights-only')){
   const table=this.closest('.na-original-info')?.querySelector('.prose table');
   if(table){const rows=[...table.rows],glue=rows.find(r=>r.textContent.includes('Para pegar')),rectangle=rows.find(r=>r.textContent.includes('46 × 92'));if(glue&&rectangle&&glue.parentNode===rectangle.parentNode)glue.parentNode.insertBefore(rectangle,glue);}
  }
  const main=this.querySelector('[data-main-image]'),dialog=this.querySelector('dialog'),zoom=this.querySelector('[data-zoom-image]');
  const buttons=[...this.querySelectorAll('[data-gallery-src]')];let active=0;
  const show=(index)=>{
   if(!buttons.length)return;
   active=(index+buttons.length)%buttons.length;const button=buttons[active];
   main.src=button.dataset.gallerySrc;main.alt=button.dataset.imageAlt;
   buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===active)));
   if(zoom){zoom.src=main.src;zoom.alt=main.alt;}
   const counter=this.querySelector('[data-photo-counter]');if(counter)counter.textContent=(active+1)+' / '+buttons.length;
  };
  buttons.forEach((button,index)=>button.addEventListener('click',()=>show(index)));
  this.querySelector('[data-prev]')?.addEventListener('click',()=>show(active-1));
  this.querySelector('[data-next]')?.addEventListener('click',()=>show(active+1));
  dialog?.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(active+1)}else if(event.key==='ArrowLeft'){event.preventDefault();show(active-1)}});
  this.querySelectorAll('input[name="na-format"]').forEach(input=>input.addEventListener('change',()=>{
   this.querySelectorAll('[data-format-panel]').forEach(p=>p.hidden=p.dataset.formatPanel!==input.value);
   this.querySelectorAll('[data-layer-panel]').forEach(p=>p.hidden=p.dataset.layerPanel!==input.value);
  }));
  this.querySelector('[data-zoom]')?.addEventListener('click',()=>{show(active);dialog.showModal()});
  this.querySelector('[data-close]')?.addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premek-claro-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-claro')) customElements.define('np-claro', class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  if(this.classList.contains('nc-highlights-only')){
   const table=this.closest('.nc-original-info')?.querySelector('.prose table');
   if(table){const rows=[...table.rows],glue=rows.find(r=>r.textContent.includes('Para pegar')),rectangle=rows.find(r=>r.textContent.includes('46 × 92'));if(glue&&rectangle&&glue.parentNode===rectangle.parentNode)glue.parentNode.insertBefore(rectangle,glue);}
  }
  const main=this.querySelector('[data-main-image]'),dialog=this.querySelector('dialog'),zoom=this.querySelector('[data-zoom-image]');
  const buttons=[...this.querySelectorAll('[data-gallery-src]')];let active=0;
  const show=(index)=>{
   if(!buttons.length)return;
   active=(index+buttons.length)%buttons.length;const button=buttons[active];
   main.src=button.dataset.gallerySrc;main.alt=button.dataset.imageAlt;
   buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===active)));
   if(zoom){zoom.src=main.src;zoom.alt=main.alt;}
   const counter=this.querySelector('[data-photo-counter]');if(counter)counter.textContent=(active+1)+' / '+buttons.length;
  };
  buttons.forEach((button,index)=>button.addEventListener('click',()=>show(index)));
  this.querySelector('[data-prev]')?.addEventListener('click',()=>show(active-1));
  this.querySelector('[data-next]')?.addEventListener('click',()=>show(active+1));
  dialog?.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(active+1)}else if(event.key==='ArrowLeft'){event.preventDefault();show(active-1)}});
  this.querySelectorAll('input[name="nc-format"]').forEach(input=>input.addEventListener('change',()=>{
   this.querySelectorAll('[data-format-panel]').forEach(p=>p.hidden=p.dataset.formatPanel!==input.value);
   this.querySelectorAll('[data-layer-panel]').forEach(p=>p.hidden=p.dataset.layerPanel!==input.value);
  }));
  this.querySelector('[data-zoom]')?.addEventListener('click',()=>{show(active);dialog.showModal()});
  this.querySelector('[data-close]')?.addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premek-documentation"] && !Shopify.designMode) return;
  try {
    function initPremekDocs(){
 document.querySelectorAll('.np-doc-hub').forEach(hub=>{
  if(hub.dataset.ready)return;hub.dataset.ready='true';
  const buttons=Array.from(hub.querySelectorAll('[data-tech-target]'));
  function select(button,open,scroll){
   buttons.forEach(b=>{const panel=hub.querySelector('#'+b.dataset.techTarget);const active=b===button&&open;panel.hidden=!active;b.setAttribute('aria-expanded',String(active));b.textContent=active?b.dataset.closeLabel:b.dataset.openLabel;});
   if(open&&scroll)hub.querySelector('#'+button.dataset.techTarget).scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  }
  buttons.forEach(b=>b.addEventListener('click',()=>select(b,b.getAttribute('aria-expanded')!=='true',true)));
  function fromHash(){let target=document.getElementById(location.hash.slice(1));if(target){let parent=target;while(parent&&parent!==hub){if(parent.tagName==='DETAILS')parent.open=true;parent=parent.parentElement;}}const b=buttons.find(b=>location.hash==='#'+b.dataset.techTarget||location.hash==='#'+b.dataset.techTarget.replace('np-doc-','np-')+'-ficha');if(b){b.closest('.np-doc-family').open=true;select(b,true,true);}}
  fromHash();window.addEventListener('hashchange',fromHash);
 });
}
initPremekDocs();document.addEventListener('DOMContentLoaded',initPremekDocs);document.addEventListener('shopify:section:load',initPremekDocs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premek-grafito-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-grafito')) customElements.define('np-grafito', class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  if(this.classList.contains('ng-highlights-only')){
   const table=this.closest('.ng-original-info')?.querySelector('.prose table');
   if(table){const rows=[...table.rows],glue=rows.find(r=>r.textContent.includes('Para pegar')),rectangle=rows.find(r=>r.textContent.includes('46 × 92'));if(glue&&rectangle&&glue.parentNode===rectangle.parentNode)glue.parentNode.insertBefore(rectangle,glue);}
  }
  const main=this.querySelector('[data-main-image]'),dialog=this.querySelector('dialog'),zoom=this.querySelector('[data-zoom-image]');
  const buttons=[...this.querySelectorAll('[data-gallery-src]')];let active=0;
  const show=(index)=>{
   if(!buttons.length)return;
   active=(index+buttons.length)%buttons.length;const button=buttons[active];
   main.src=button.dataset.gallerySrc;main.alt=button.dataset.imageAlt;
   buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===active)));
   if(zoom){zoom.src=main.src;zoom.alt=main.alt;}
   const counter=this.querySelector('[data-photo-counter]');if(counter)counter.textContent=(active+1)+' / '+buttons.length;
  };
  buttons.forEach((button,index)=>button.addEventListener('click',()=>show(index)));
  this.querySelector('[data-prev]')?.addEventListener('click',()=>show(active-1));
  this.querySelector('[data-next]')?.addEventListener('click',()=>show(active+1));
  dialog?.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(active+1)}else if(event.key==='ArrowLeft'){event.preventDefault();show(active-1)}});
  this.querySelectorAll('input[name="ng-format"]').forEach(input=>input.addEventListener('change',()=>{
   this.querySelectorAll('[data-format-panel]').forEach(p=>p.hidden=p.dataset.formatPanel!==input.value);
   this.querySelectorAll('[data-layer-panel]').forEach(p=>p.hidden=p.dataset.layerPanel!==input.value);
  }));
  this.querySelector('[data-zoom]')?.addEventListener('click',()=>{show(active);dialog.showModal()});
  this.querySelector('[data-close]')?.addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premek-lino-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-lino')) customElements.define('np-lino', class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  if(this.classList.contains('nl-highlights-only')){
   const table=this.closest('.nl-original-info')?.querySelector('.prose table');
   if(table){const rows=[...table.rows],glue=rows.find(r=>r.textContent.includes('Para pegar')),rectangle=rows.find(r=>r.textContent.includes('46 × 92'));if(glue&&rectangle&&glue.parentNode===rectangle.parentNode)glue.parentNode.insertBefore(rectangle,glue);}
  }
  const main=this.querySelector('[data-main-image]'),dialog=this.querySelector('dialog'),zoom=this.querySelector('[data-zoom-image]');
  const buttons=[...this.querySelectorAll('[data-gallery-src]')];let active=0;
  const show=(index)=>{
   if(!buttons.length)return;
   active=(index+buttons.length)%buttons.length;const button=buttons[active];
   main.src=button.dataset.gallerySrc;main.alt=button.dataset.imageAlt;
   buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===active)));
   if(zoom){zoom.src=main.src;zoom.alt=main.alt;}
   const counter=this.querySelector('[data-photo-counter]');if(counter)counter.textContent=(active+1)+' / '+buttons.length;
  };
  buttons.forEach((button,index)=>button.addEventListener('click',()=>show(index)));
  this.querySelector('[data-prev]')?.addEventListener('click',()=>show(active-1));
  this.querySelector('[data-next]')?.addEventListener('click',()=>show(active+1));
  dialog?.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(active+1)}else if(event.key==='ArrowLeft'){event.preventDefault();show(active-1)}});
  this.querySelectorAll('input[name="nl-format"]').forEach(input=>input.addEventListener('change',()=>{
   this.querySelectorAll('[data-format-panel]').forEach(p=>p.hidden=p.dataset.formatPanel!==input.value);
   this.querySelectorAll('[data-layer-panel]').forEach(p=>p.hidden=p.dataset.layerPanel!==input.value);
  }));
  this.querySelector('[data-zoom]')?.addEventListener('click',()=>{show(active);dialog.showModal()});
  this.querySelector('[data-close]')?.addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premek-negro-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-negro')) customElements.define('np-negro', class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  if(this.classList.contains('nn-highlights-only')){
   const table=this.closest('.nn-original-info')?.querySelector('.prose table');
   if(table){const rows=[...table.rows],glue=rows.find(r=>r.textContent.includes('Para pegar')),rectangle=rows.find(r=>r.textContent.includes('46 × 92'));if(glue&&rectangle&&glue.parentNode===rectangle.parentNode)glue.parentNode.insertBefore(rectangle,glue);}
  }
  const main=this.querySelector('[data-main-image]'),dialog=this.querySelector('dialog'),zoom=this.querySelector('[data-zoom-image]');
  const buttons=[...this.querySelectorAll('[data-gallery-src]')];let active=0;
  const show=(index)=>{
   if(!buttons.length)return;
   active=(index+buttons.length)%buttons.length;const button=buttons[active];
   main.src=button.dataset.gallerySrc;main.alt=button.dataset.imageAlt;
   buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===active)));
   if(zoom){zoom.src=main.src;zoom.alt=main.alt;}
   const counter=this.querySelector('[data-photo-counter]');if(counter)counter.textContent=(active+1)+' / '+buttons.length;
  };
  buttons.forEach((button,index)=>button.addEventListener('click',()=>show(index)));
  this.querySelector('[data-prev]')?.addEventListener('click',()=>show(active-1));
  this.querySelector('[data-next]')?.addEventListener('click',()=>show(active+1));
  dialog?.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(active+1)}else if(event.key==='ArrowLeft'){event.preventDefault();show(active-1)}});
  this.querySelectorAll('input[name="nn-format"]').forEach(input=>input.addEventListener('change',()=>{
   this.querySelectorAll('[data-format-panel]').forEach(p=>p.hidden=p.dataset.formatPanel!==input.value);
   this.querySelectorAll('[data-layer-panel]').forEach(p=>p.hidden=p.dataset.layerPanel!==input.value);
  }));
  this.querySelector('[data-zoom]')?.addEventListener('click',()=>{show(active);dialog.showModal()});
  this.querySelector('[data-close]')?.addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premek-performance"] && !Shopify.designMode) return;
  try {
    (()=>{const chart=document.querySelector('.pp-chart');if(!chart||!('IntersectionObserver' in window))return;const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){chart.classList.add('pp-visible');observer.disconnect();}},{threshold:.25});observer.observe(chart);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premek-sample-prefill"] && !Shopify.designMode) return;
  try {
    function premekSamplePrefill() {
  const params = new URLSearchParams(window.location.search);
  const formats = {square:'47 × 47 cm · Autoposante · 5 mm',glue:'47 × 47 cm · Para pegar · 3 mm',rectangle:'46 × 92 cm · Autoposante · 5 mm'};
  if(params.get('product_design') === 'cemento-taupe' && formats[params.get('presentation')]){
    const chosen = 'Cemento Taupe · NP Studio · '+formats[params.get('presentation')];
    const field = document.getElementById('pc-product'), message = document.getElementById('pc-message');
    const copy = document.querySelector('[data-premek-taupe-copy]');
    const kind = ['sample','datasheet'].includes(params.get('request')) ? params.get('request') : 'quote';
    if(field && !field.value.trim())field.value=chosen;
    if(message && !message.value.trim() && copy)message.value=copy.dataset[kind].replace('__PRODUCT__',chosen);
    return;
  }
  const choice = new URLSearchParams(window.location.search).get('sample_collection');
  const allowed = ['NP Urban','NP Studio','NP Nordic','NP Heritage','NP Chromatic','NP Granito','NP Espiga','NP Terrazo','advice'];
  const copy = document.querySelector('[data-premek-sample-copy]');
  if (!copy || !allowed.includes(choice)) return;
  const collection = choice === 'advice' ? copy.dataset.advice : choice;
  const product = document.getElementById('pc-product');
  const message = document.getElementById('pc-message');
  if (product && !product.value.trim()) product.value = collection;
  if (message && !message.value.trim()) {
    message.value = copy.dataset.message.replace('__COLLECTION__', collection);
    message.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', premekSamplePrefill);
else premekSamplePrefill();
document.addEventListener('shopify:section:load', premekSamplePrefill);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premek-taupe-pilot"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-taupe')) customElements.define('np-taupe', class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  if(this.classList.contains('nt-highlights-only')){
   const table=this.closest('.nt-original-info')?.querySelector('.prose table');
   if(table){const rows=[...table.rows],glue=rows.find(r=>r.textContent.includes('Para pegar')),rectangle=rows.find(r=>r.textContent.includes('46 × 92'));if(glue&&rectangle&&glue.parentNode===rectangle.parentNode)glue.parentNode.insertBefore(rectangle,glue);}
  }
  const main=this.querySelector('[data-main-image]'),dialog=this.querySelector('dialog'),zoom=this.querySelector('[data-zoom-image]');
  const buttons=[...this.querySelectorAll('[data-gallery-src]')];let active=0;
  const show=(index)=>{
   if(!buttons.length)return;
   active=(index+buttons.length)%buttons.length;const button=buttons[active];
   main.src=button.dataset.gallerySrc;main.alt=button.dataset.imageAlt;
   buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===active)));
   if(zoom){zoom.src=main.src;zoom.alt=main.alt;}
   const counter=this.querySelector('[data-photo-counter]');if(counter)counter.textContent=(active+1)+' / '+buttons.length;
  };
  buttons.forEach((button,index)=>button.addEventListener('click',()=>show(index)));
  this.querySelector('[data-prev]')?.addEventListener('click',()=>show(active-1));
  this.querySelector('[data-next]')?.addEventListener('click',()=>show(active+1));
  dialog?.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(active+1)}else if(event.key==='ArrowLeft'){event.preventDefault();show(active-1)}});
  this.querySelectorAll('input[name="nt-format"]').forEach(input=>input.addEventListener('change',()=>{
   this.querySelectorAll('[data-format-panel]').forEach(p=>p.hidden=p.dataset.formatPanel!==input.value);
   this.querySelectorAll('[data-layer-panel]').forEach(p=>p.hidden=p.dataset.layerPanel!==input.value);
  }));
  this.querySelector('[data-zoom]')?.addEventListener('click',()=>{show(active);dialog.showModal()});
  this.querySelector('[data-close]')?.addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premek-turf-docs"] && !Shopify.designMode) return;
  try {
    function openPremekTurf(){const id=location.hash.slice(1);if(id.startsWith('ficha-')){const detail=document.getElementById(id);if(detail&&detail.closest('.np-turf-docs'))detail.open=true;}}
openPremekTurf();window.addEventListener('hashchange',openPremekTurf);
  } catch(e) { console.error(e); }
})();

})();
